/*eslint-disable prefer-const */
/*eslint-disable eqeqeq */
//Third party packages
import store from 'src/redux/store';
import extractDomain from 'extract-domain';

import { axiosInstance } from 'src/api/axios';
import RetryAPI from 'src/Member/api/RetryAPI';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from 'src/Member/errorhandling/HttpErrorCodes';

class HttpHeader {
  contructor() {
    this.cname = '';
    this.domainName = '';
    this.device = '';
    this.encryptionKey = '';
  }

  async getEncryptionKeyStore() {
    try {
      const keyStoreResp = await axiosInstance.get(
        APIEndpoints.getEncryptionKeyResources(),
      );

      const keyStoreDataResp = keyStoreResp.data;

      if (keyStoreResp.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        this.setEncryptionKey(keyStoreDataResp.Response.SymmetricKey);

        RetryAPI.resetRetryCount();
        RetryAPI.setResponseReceived(true);
      } else {
        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(keyStoreResp.status);
      }
    } catch (error) {
      if (error) RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);

      if (error.response) RetryAPI.setErrorCode(error.response.status);

      RetryAPI.incrementRetryCount();
      RetryAPI.setResponseReceived(false);
    }
  }

  getEncryptionKey() {
    if (this.encryptionKey == '' || typeof this.encryptionKey == 'undefined')
      this.encryptionKey = store.getState()?.key?.encryptionValue?.SymmetricKey;

    return this.encryptionKey;
  }

  setEncryptionKey(encryptionKey) {
    this.encryptionKey = encryptionKey;
  }

  getCNAME = () => {
    let hostname = '',
      url = '',
      domain = '';
    url = window.location.href;

    hostname = window.location.hostname;

    if (hostname == 'localhost') {
      //this.cname = 'a1m-qa';
      this.cname = 'a1m-test';
      return this.cname;
    }

    this.domainName = extractDomain(url);

    if (this.domainName == 'amazonaws.com') this.cname = 'a1m-qa';
    else {
      domain = url.substring(
        url.lastIndexOf('/', url.lastIndexOf('.') - 1) + 1,
      );
      this.cname = domain.substring(0, domain.indexOf('.'));
    }

    return this.cname;
  };

  getDomainName = () => {
    let url, hostname;
    url = window.location.href;

    hostname = window.location.hostname;

    if (hostname == 'localhost') {
      this.domainName = 'mphasishealthportal.com';
      // this.domainName = 'eldocomp.com';
      return this.domainName;
    }

    this.domainName = extractDomain(url);

    if (this.domainName == 'amazonaws.com') this.domainName = 'eldocomp.com';

    return this.domainName;
  };

  getDevice = () => {
    this.device = 'Browser';

    return this.device;
  };
}

export default new HttpHeader();
